import React from 'react';
export function Footer() {
  return <footer className="bg-blue-900 text-blue-200 py-8 text-center text-sm" data-id="element-97">
      <div className="max-w-4xl mx-auto px-4" data-id="element-98">
        <p className="mb-4" data-id="element-99">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
        <p data-id="element-100">
          &copy; {new Date().getFullYear()} Handball Coach Pro. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}